import _t from 'i18n!nls/front-page';

const getDomainData = (): { slug: string; name: string }[] => {
  return [
    {
      slug: 'data-science',
      name: _t('Data Science'),
    },
    {
      slug: 'business',
      name: _t('Business'),
    },
    {
      slug: 'computer-science',
      name: _t('Computer Science'),
    },
    {
      slug: 'health',
      name: _t('Health'),
    },
    {
      slug: 'social-sciences',
      name: _t('Social Sciences'),
    },
    {
      slug: 'personal-development',
      name: _t('Personal Development'),
    },
    {
      slug: 'arts-and-humanities',
      name: _t('Arts and Humanities'),
    },
    {
      slug: 'physical-science-and-engineering',
      name: _t('Physical Science and Engineering'),
    },
    {
      slug: 'language-learning',
      name: _t('Language Learning'),
    },
    {
      slug: 'information-technology',
      name: _t('Information Technology'),
    },
    {
      slug: 'math-and-logic',
      name: _t('Math and Logic'),
    },
  ];
};

export default getDomainData;
